import { observable, action, computed } from 'mobx';
import { CreateAccessTokenResponseDto } from 'Api/Features/Authentication/Dtos/CreateAccessTokenResponseDto';

class AuthenticationStore {
    @observable accessToken?: string | null | undefined = sessionStorage.accessToken;
    @observable refreshToken?: string | null = sessionStorage.refreshToken;
    @observable tokenType?: string | null = sessionStorage.tokenType;
    @observable expiresIn?: number = parseInt(sessionStorage.expiresIn, 10);
    @observable userName?: string | null = sessionStorage.userName;
    @observable userId?: string | null = sessionStorage.userId;
    @observable expirationTimeStamp: number | null = parseInt(
        sessionStorage.expirationTimeStamp,
        10
    );

    @computed
    get loggedIn(): boolean {
        return !!this.accessToken;
    }

    @action
    setSession(result: CreateAccessTokenResponseDto): void {
        this.userId = sessionStorage.userId = result.user_id;
        this.userName = sessionStorage.userName = result.user_name;
        this.tokenType = sessionStorage.tokenType = result.token_type;
        this.accessToken = sessionStorage.accessToken = result.access_token;
        this.expiresIn = sessionStorage.expiresIn = result.expires_in;
        this.refreshToken = sessionStorage.refreshToken = result.refresh_token;
        this.expirationTimeStamp = sessionStorage.expirationTimeStamp =
            Math.round(Date.now() / 1000) + (result.expires_in || -1);
    }

    @action
    clearSession(): void {
        this.accessToken = '';
        this.refreshToken = '';
        this.tokenType = '';
        this.expiresIn = 0;
        this.userId = '';
        this.userName = '';
        sessionStorage.clear();
    }
}

export default AuthenticationStore;
